
export class Exceptions {
  public id: number;
  public plantcode: string;
  public alarmcode: string;
  public level: string;
  public availableperson: string;
  public voice: boolean;
  public sms: boolean;
  public mail: boolean;
  public tag: string;

  constructor(
    id: number,
    plantcode: string,
    alarmcode: string,
    level: string,
    availableperson: string,
    voice: boolean,
    sms: boolean,
    mail: boolean,
    tag: string
  ) {
    this.id = id;
    this.plantcode = plantcode;
    this.alarmcode = alarmcode;
    this.level = level;
    this.availableperson = availableperson;
    this.voice = voice;
    this.sms = sms;
    this.mail = mail;
    this.tag = tag;
  }

}
